import { render, staticRenderFns } from "./EarningStatistic.vue?vue&type=template&id=151953a4"
import script from "./EarningStatistic.vue?vue&type=script&lang=js"
export * from "./EarningStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports